import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { submitContactInquiry } from '../services/api';
import usePageMeta from '../hooks/usePageMeta';
import { trackGoogleAdsConversion } from '../lib/googleAds';
import '../styles/contact.css';

const initialForm = {
  name: '',
  email: '',
  company: '',
  subject: '',
  message: '',
};

function Contact() {
  usePageMeta({
    title: 'Contact',
    description: 'Contact Risqly Cybersecurity for partnerships, product questions, or support requests.',
  });

  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (successMessage) setSuccessMessage('');
    if (errorMessage) setErrorMessage('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      await submitContactInquiry(form);
      trackGoogleAdsConversion('contact_sales');
      setSuccessMessage('Thanks for reaching out. We received your inquiry and will get back to you soon.');
      setForm(initialForm);
    } catch (error) {
      const apiMessage = error.response?.data?.error;
      setErrorMessage(apiMessage || 'Failed to submit your inquiry. Please try again in a moment.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page-root">
      <Header />
      <main className="contact-main">
        <section className="contact-hero">
          <h1>Contact Risqly Cybersecurity</h1>
          <p>
            Reach out for partnerships, product questions, or support requests. We will route your inquiry to the right team.
          </p>
        </section>

        <section className="contact-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-form-grid">
              <label className="contact-field">
                <span>Name</span>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  maxLength={120}
                />
              </label>

              <label className="contact-field">
                <span>Email</span>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  maxLength={255}
                />
              </label>

              <label className="contact-field">
                <span>Company (optional)</span>
                <input
                  type="text"
                  name="company"
                  value={form.company}
                  onChange={handleChange}
                  maxLength={160}
                />
              </label>

              <label className="contact-field">
                <span>Subject</span>
                <input
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  maxLength={160}
                />
              </label>
            </div>

            <label className="contact-field contact-field-full">
              <span>Message</span>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                minLength={10}
                maxLength={3000}
                rows={8}
              />
            </label>

            {successMessage && <div className="contact-feedback success">{successMessage}</div>}
            {errorMessage && <div className="contact-feedback error">{errorMessage}</div>}

            <button className="btn btn-primary contact-submit" type="submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Inquiry'}
            </button>
          </form>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Contact;
